import React, { useRef } from "react";
import { X } from "lucide-react";
import DocumentPrintTemplate from "./DocumentPrintTemplate";

const DocumentPreviewModal = ({
  document,
  open,
  onClose,
  onPrint,
  onDownload,
  downloading,
  printRef,
}) => {
  const localRef = useRef(null);
  const resolvedRef = printRef || localRef;

  if (!open || !document) return null;

  return (
    <div className="document-print-preview-modal no-print" role="dialog" aria-modal="true" aria-label="Document print preview">
      <div className="document-print-preview-shell">
        <div className="document-print-preview-header">
          <div>
            <h2>Preview</h2>
            <p>
              {document.title} {document.meta?.number ? `- ${document.meta.number}` : ""}
            </p>
          </div>
          <div className="document-print-preview-buttons">
            <button className="document-print-preview-primary" onClick={onPrint}>Print</button>
            <button className="document-print-preview-secondary" onClick={onDownload} disabled={downloading}>
              {downloading ? "Generating PDF..." : "Download PDF"}
            </button>
            <button className="document-print-preview-secondary" onClick={onClose}>
              <X size={16} /> Close
            </button>
          </div>
        </div>
        <div className="document-print-preview-body">
          <aside className="document-print-preview-sidebar">
            <div className="document-print-preview-thumb">
              <DocumentPrintTemplate document={document} />
            </div>
            <span>1</span>
          </aside>
          <main className="document-print-preview-stage">
            <div className="document-print-preview-page">
              <DocumentPrintTemplate ref={resolvedRef} document={document} />
            </div>
          </main>
        </div>
      </div>
    </div>
  );
};

export default DocumentPreviewModal;
